module.exports = "div.md-col-12 {\n  text-align: center; }\n"